import React, { useState, useEffect } from 'react';
import './ContactForm.css'; // Assuming the CSS is in this file
import axios from 'axios';

function ContactForm() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 5000); // Simulating loading for 5 seconds
  }, []);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      FullName: name,
      Email: email,
      Phone: phone,
      Message: comment,
    };

    // Make the POST request to the backend
    axios
      .post('https://planezy-backened-sb7y.onrender.com/contact', data)
      .then((result) => {
        console.log('Data sent successfully', result);
      })
      .catch((err) => {
        console.log('Error sending data', err);
      });
  };

  return (
    <>
      <div className="contact">
        <div className="container contact">
          <div className="row">
            <div className="col-md-3">
              <div className="contact-info">
                <img src="https://image.ibb.co/kUASdV/contact-image.png" alt="image" />
                <h2>Contact Us</h2>
                <h4>We would love to hear from you!</h4>
              </div>
            </div>
            <div className="col-md-9">
              <form onSubmit={handleSubmit}>
                <div className="contact-form">
                  <div className="form-group">
                    <label className="control-label col-sm-2" htmlFor="fname">
                      Full Name:
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="fname"
                        placeholder="Enter Full Name"
                        name="fname"
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-sm-2" htmlFor="email">
                      Email:
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Enter Email"
                        name="email"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-sm-2" htmlFor="phone">
                      Phone:
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        placeholder="Enter Phone Number"
                        name="phone"
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-sm-2" htmlFor="comment">
                      Comment:
                    </label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control"
                        rows="5"
                        id="comment"
                        name="comment"
                        onChange={(e) => setComment(e.target.value)}
                      ></textarea>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-sm-offset-2 col-sm-10">
                      <button type="submit" className="btn btn-default">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactForm;


// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     fname: '',
//     lname: '',
//     email: '',
//     comment: ''
//   });

//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });
//   };

//   // Handle form submit
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form submitted:', formData);
//   };

//   return (
//     <div className="container contact">
//       <div className="row">
//         <div className="col-md-3">
//           <div className="contact-info">
//             <img
//               src="https://image.ibb.co/kUASdV/contact-image.png"
//               alt="contact"
//             />
//             <h2>Contact Us</h2>
//             <h4>We would love to hear from you!</h4>
//           </div>
//         </div>
//         <div className="col-md-9">
//           <div className="contact-form">
//             <form onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <label className="control-label col-sm-2" htmlFor="fname">
//                   Full Name :
//                 </label>
//                 <div className="col-sm-10">
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="fname"
//                     name="fname"
//                     value={formData.fname}
//                     onChange={handleChange}
//                     placeholder="Enter Full Name"
//                   />
//                 </div>
//               </div>

             

//               <div className="form-group">
//                 <label className="control-label col-sm-2" htmlFor="email">
//                   Email:
//                 </label>
//                 <div className="col-sm-10">
//                   <input
//                     type="email"
//                     className="form-control"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="Enter Email"
//                   />
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label className="control-label col-sm-2" htmlFor="lname">
//                   Phone Number:
//                 </label>
//                 <div className="col-sm-10">
//                   <input
//                     type="Number"
//                     className="form-control"
//                     id="lname"
//                     name="lname"
//                     value={formData.lname}
//                     onChange={handleChange}
//                     placeholder="Enter Phone Number"
//                   />
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label className="control-label col-sm-2" htmlFor="comment">
//                   Comment:
//                 </label>
//                 <div className="col-sm-10">
//                   <textarea
//                     className="form-control"
//                     rows="5"
//                     id="comment"
//                     name="comment"
//                     value={formData.comment}
//                     onChange={handleChange}
//                   ></textarea>
//                 </div>
//               </div>

//               <div className="form-group">
//                 <div className="col-sm-offset-2 col-sm-10">
//                   <button type="submit" className="btn btn-default">
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };